import PortalIdParser from 'PortalIdParser';
import { useMemo } from 'react';
export function usePortalIdParser() {
  return useMemo(() => {
    return PortalIdParser.get();
  }, []);
}